var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { insuranceStorybook } from "./insuranceDto";
import { InsuranceView } from "../insurance/view";
import { getCustomerAction } from "../../fnx/customer";
import AfyDefault from "../../assets/images/IsuranceDefault.png";
import { icons, position, theme, ToastAFY, typeAlert, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { useNavigate } from "react-router-dom";
import LocalStorageService from "../../services/localStorage";
import { navigateNext } from "../../dataBase/stepProgress";
import { transformToSelect } from "../../services/functions";
import { personByIdClearData, personClearData, } from "../../store/person/actions";
import { regionClearData } from "../../store/region/actions";
import { hasPermission } from "../../services/getNavigationPages";
import { pageActionFlagsApi, pageActionFlagsClearData, } from "../../store/pageActionFlags/actions";
import { quoteClearData } from "../../store/generateQuote/actions";
import { planBenefitClearData } from "../../store/planBenefit/actions";
import { plansClearData } from "../../store/plans/actions";
import { paymentModeClearData } from "../../store/paymentModes/action";
import showToast from "../../services/toast";
import { showErrorToast } from "../../fnx/showError";
import { useTranslation } from "react-i18next";
import { sponsor } from "../../store/sponsor/actions";
import { GetProjectAll } from "../../fnx/project/projectAll";
import { projectClearData } from "../../store/project/actions";
import { STEP_INSURANCE } from "../../const/catalog";
import { AlertLoadingHeader } from "../../components/alertLoadingComponent/alertLoading";
var storageKey2 = "assurehub";
var lsLogin = new LocalStorageService(storageKey2);
var storageKey = "afy-steps";
var localStorageService = new LocalStorageService(storageKey);
var storageKey3 = "afy-action-flags";
var lsPageActionFlags = new LocalStorageService(storageKey3);
var STEP = STEP_INSURANCE;
var campaign;
var campaignSelected;
var Insurance = function () {
    var t = useTranslation().t;
    var dispatch = useDispatch();
    var navigate = useNavigate();
    var _a = useState(false), trigger = _a[0], setTrigger = _a[1];
    var clientId = React.useState(lsLogin.getUserLoginStored().clientId)[0];
    var company = React.useState(lsLogin.getUserLoginStored().subdomain || "")[0];
    var _b = React.useState(true), enable = _b[0], setEnable = _b[1];
    var _c = React.useState(1), page = _c[0], setPage = _c[1];
    var _d = React.useState(100), limit = _d[0], setLimit = _d[1];
    var _e = React.useState([]), steps = _e[0], setSteps = _e[1];
    var _f = React.useState([]), breadCrumbs = _f[0], setBreadCrumbs = _f[1];
    var _g = React.useState(""), descriptionInsurance = _g[0], setDescriptionInsurance = _g[1];
    var _h = useState(1), insurancePage = _h[0], setInsurancePage = _h[1];
    var _j = useState(20), insuranceLimit = _j[0], setInsuranceLimit = _j[1];
    var _k = useState(0), countPagination = _k[0], setCountPagination = _k[1];
    var _l = useState(false), insuranceTrigger = _l[0], setInsuranceTrigger = _l[1];
    var _m = React.useState(true), showIcon = _m[0], setShowIcon = _m[1];
    var _o = React.useState(insuranceStorybook(t)), insurance = _o[0], setInsurance = _o[1];
    var _p = React.useState([]), insuranceFilters = _p[0], setInsuranceFilters = _p[1];
    var _q = React.useState(""), logoImg = _q[0], setLogoImg = _q[1];
    var _r = React.useState(icons.EmojiTransportation), iconPage = _r[0], setIconPage = _r[1];
    var _s = React.useState(""), sponsorsIds = _s[0], setSponsorsIds = _s[1];
    var _t = React.useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _t[0], setSeeToast = _t[1];
    var _u = useSelector(function (state) {
        var _a;
        return ({
            responseSponsor: (_a = state.Sponsor.responseSponsor) === null || _a === void 0 ? void 0 : _a.data,
            errorSponsor: state.Sponsor.errorSponsor,
            loadingSponsor: state.Sponsor.loadingSponsor,
        });
    }), responseSponsor = _u.responseSponsor, errorSponsor = _u.errorSponsor, loadingSponsor = _u.loadingSponsor;
    var _v = GetProjectAll(insuranceTrigger, enable, insurancePage, insuranceLimit, sponsorsIds, descriptionInsurance), responseProject = _v.responseProject, errorProject = _v.errorProject, loadingProject = _v.loadingProject;
    var callSponsor = function () {
        setTrigger(!trigger);
    };
    var _w = useSelector(function (state) {
        var _a;
        return ({
            responsePageActionFlags: (_a = state.PageActionFlags.responsePageActionFlags) === null || _a === void 0 ? void 0 : _a.data,
            errorPageActionFlags: state.PageActionFlags.errorPageActionFlags,
            loadingPageActionFlags: state.PageActionFlags.loadingPageActionFlags,
        });
    }), responsePageActionFlags = _w.responsePageActionFlags, errorPageActionFlags = _w.errorPageActionFlags, loadingPageActionFlags = _w.loadingPageActionFlags;
    useEffect(function () {
        // setBreadCrumbs(stepProgress(STEP, true));
        // setSteps(stepProgress(STEP));
        callSponsor();
        dispatch(personClearData());
        dispatch(personByIdClearData());
        dispatch(regionClearData());
        dispatch(planBenefitClearData());
        dispatch(plansClearData());
        dispatch(paymentModeClearData());
        dispatch(pageActionFlagsClearData());
        dispatch(sponsor({
            enable: enable,
            page: page,
            limit: limit,
            clientId: clientId,
        }));
    }, []);
    useEffect(function () {
        if (responseSponsor && (responseSponsor === null || responseSponsor === void 0 ? void 0 : responseSponsor.length) > 0) {
            var idSponsor = responseSponsor
                .map(function (item) { return item.id; })
                .join("&sponsorId=");
            setSponsorsIds(idSponsor);
            setInsuranceTrigger(true);
        }
    }, [responseSponsor]);
    useEffect(function () {
        if (errorSponsor) {
            showErrorToast(errorSponsor, setSeeToast, t);
        }
    }, [errorSponsor]);
    useEffect(function () {
        if (errorProject) {
            showErrorToast(errorProject, setSeeToast, t);
        }
    }, [errorProject]);
    useEffect(function () {
        var loadData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var dataST;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(responseProject && (responseProject === null || responseProject === void 0 ? void 0 : responseProject.data))) return [3 /*break*/, 2];
                        return [4 /*yield*/, Promise.all(responseProject === null || responseProject === void 0 ? void 0 : responseProject.data.map(function (item) { return __awaiter(void 0, void 0, void 0, function () {
                                var imageExists;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, checkImage(item.logoUrl)];
                                        case 1:
                                            imageExists = _a.sent();
                                            return [2 /*return*/, {
                                                    id: item.id,
                                                    title: item.description,
                                                    text: item.logoUrl && imageExists
                                                        ? ""
                                                        : item.description.slice(0, 2),
                                                    logoUrl: item.logoUrl && imageExists ? item.logoUrl : AfyDefault,
                                                    logo: item.logoUrl && imageExists ? item.logoUrl : AfyDefault,
                                                    backgroundColor: "#FFFFFF",
                                                    textColor: "#0D0D0D",
                                                    campaign: transformToSelect(item.campaign),
                                                    flow: item.salesFlow,
                                                }];
                                    }
                                });
                            }); }))];
                    case 1:
                        dataST = _a.sent();
                        setInsurance(__assign(__assign({}, insurance), { data: dataST }));
                        _a.label = 2;
                    case 2:
                        if (responseProject === null || responseProject === void 0 ? void 0 : responseProject.pagingInfo) {
                            setCountPagination(responseProject === null || responseProject === void 0 ? void 0 : responseProject.pagingInfo.totalItems);
                        }
                        dispatch(projectClearData());
                        return [2 /*return*/];
                }
            });
        }); };
        loadData();
        setShowIcon(getCustomerAction().customerAuto.includes(company));
        setLogoImg("");
    }, [responseProject]);
    useEffect(function () {
        if (responsePageActionFlags && (responsePageActionFlags === null || responsePageActionFlags === void 0 ? void 0 : responsePageActionFlags.length) > 0) {
            lsPageActionFlags.setPageActionFlagsStored(responsePageActionFlags);
            dispatch(pageActionFlagsClearData());
            //navigate("/plan");
        }
        if (responsePageActionFlags && (responsePageActionFlags === null || responsePageActionFlags === void 0 ? void 0 : responsePageActionFlags.length) === 0) {
            setSeeToast({
                show: true,
                message: t("product.noData"),
                type: typeAlert.error,
            });
        }
    }, [responsePageActionFlags]);
    useEffect(function () {
        if (responseSponsor) {
            var dataST_1 = [];
            responseSponsor.map(function (item) {
                dataST_1.push({
                    active: false,
                    id: item.id,
                    name: item.name,
                });
            });
            setInsuranceFilters(dataST_1);
        }
    }, [responseSponsor]);
    var checkImage = function (url) {
        return new Promise(function (resolve) {
            var img = new Image();
            img.onload = function () { return resolve(true); };
            img.onerror = function () { return resolve(false); };
            img.src = url;
        });
    };
    var clickCard = function (card) {
        var _a;
        localStorage.removeItem("afy-steps");
        dispatch(quoteClearData());
        var ins = (_a = insurance.data) === null || _a === void 0 ? void 0 : _a.find(function (i) { return i.id === card.id; });
        campaignSelected = card.campaign ? card.campaign[0] : "";
        campaign = card.campaign;
        // localStorageService.setStepStored({
        //   id: card.id,
        //   name: card.title as string,
        //   step: Steps.insurance,
        //   completed: true,
        //   campaign: card.campaign!,
        //   campaignSelected: card.campaign ? card.campaign[0] : "",
        //   flow: ins?.flow,
        // });
        if (getCustomerAction().customerAuto.includes(lsLogin.getUserLoginStored().subdomain || "")) {
            setTrigger(true);
        }
        if (responseProject && responseProject.data) {
            var ri = responseProject === null || responseProject === void 0 ? void 0 : responseProject.data.find(function (i) { return i.id === card.id; });
            if (ri) {
                // localStorageService.setStepStored({
                //   id: ri.projectTypeInfo.id,
                //   name: ri.projectTypeInfo.description as string,
                //   step: Steps.insurance,
                //   completed: true,
                //   flow: ins?.flow,
                // });
            }
        }
        //Get pageActionFlags
        callDispatchPageActionFlags(card.id);
        // if (lsLogin.getUserLoginStored().subdomain !== "apap-auto") {
        navigateNext(STEP, navigate);
        // }
        return (_jsx(ToastAFY, { autoclose: 5000, closeOnClick: true, newstOnTop: true, pauseOnHover: true, position: position.topRight, theme: theme.light, title: t("product.selected"), type: typeAlert.success }));
    };
    var onChangeFilters = function (data) {
        var _a;
        if (data.length > 0) {
            var idSponsor = (_a = data === null || data === void 0 ? void 0 : data.sponsor) === null || _a === void 0 ? void 0 : _a.map(function (item) { return item.id; }).join("&sponsorId=");
            setSponsorsIds(idSponsor);
        }
        else {
            var oldIdSponsor = sponsorsIds;
            setDescriptionInsurance("");
            setSponsorsIds(oldIdSponsor);
        }
    };
    var clickView = function (view) {
        var insuranceObj = __assign(__assign({}, insurance), { viewType: view.id });
        setInsurance(insuranceObj);
    };
    var searchFilter = function (term) {
        setDescriptionInsurance(term);
    };
    var callDispatchPageActionFlags = function (id) {
        dispatch(pageActionFlagsApi({
            enable: enable,
            page: page,
            limit: limit,
            clientId: clientId,
            projectId: id,
        }));
    };
    var onChangePage = function (e) {
        setInsurancePage(e);
        setInsuranceTrigger(true);
    };
    var onChangeRowsPerPage = function (e) {
        setInsuranceLimit(e);
        setInsuranceTrigger(true);
    };
    return (_jsxs(_Fragment, { children: [_jsx(AlertLoadingHeader, { loading: loadingSponsor || loadingProject, seeToast: seeToast, showToast: showToast, setSeeToast: setSeeToast, titleLoading: t("product.loading") }), _jsx(InsuranceView, { insurance: insurance, breadCrumbs: breadCrumbs, searchFilter: searchFilter, clickView: clickView, clickCard: hasPermission("sale-product-create") ? clickCard : function () { }, 
                // clickChip={clickChip}
                steps: steps, insurancePage: insurancePage, insuranceLimit: insuranceLimit, countPagination: countPagination, onChangePage: onChangePage, onChangeRowsPerPage: onChangeRowsPerPage, showIcon: showIcon, iconPage: iconPage, logoImg: logoImg, onChangeFilters: onChangeFilters, insuranceFilters: insuranceFilters })] }));
};
export default Insurance;
